"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const rxjs_1 = require("rxjs");
// ----------------------------------------------------------------
// Custom React Hooks to help with RxJS
function useObservable(observable, defaultValue, inputs = [observable]) {
    const [t, setT] = react_1.useState(defaultValue);
    react_1.useEffect(() => {
        const subs = observable.subscribe((t) => {
            if (useObservable.debug)
                console.log("---- useObservable", t);
            setT(t);
        });
        return () => subs.unsubscribe();
    }, inputs);
    return t;
}
exports.useObservable = useObservable;
useObservable.debug = false;
function useBehaviorSubject(subject, debugF) {
    // React hook always have to call `useState`, even if not passed a BehaviorSubject
    const [t, setT] = react_1.useState(subject instanceof rxjs_1.BehaviorSubject ?
        subject.value : subject);
    // Default case of no BehaviorSubject given
    if (!(subject instanceof rxjs_1.BehaviorSubject))
        return t;
    react_1.useEffect(() => {
        const subs = subject.subscribe((tNew) => {
            if (debugF)
                debugF(tNew);
            setT(tNew);
        });
        return () => subs.unsubscribe();
    }, [subject]);
    return t;
}
exports.useBehaviorSubject = useBehaviorSubject;
function useObserving(observable, callback, inputs = [observable]) {
    react_1.useEffect(() => {
        const subs = observable.subscribe(t => {
            if (useObserving.debug)
                console.log("---- useObserving", t);
            callback(t);
        });
        return () => subs.unsubscribe();
    }, [observable]);
}
exports.useObserving = useObserving;
useObserving.debug = false;
// -----------------------------------------------------------------------
// Focuses the given element whenever a `true` gets sent on the given Queue.
// Blurs if `false` is sent.
function useFocusing(ref, doFocus) {
    react_1.useEffect(() => {
        return doFocus.subscribe(focus => ref.current &&
            (focus ?
                ref.current.focus() :
                ref.current.blur()));
    });
}
exports.useFocusing = useFocusing;
